


// import SectionCard from "../ui/SectionCard";

// import {
//   supplierOptions,
//   paymentMethodOptions,
//  // billingFreqOptions,
// } from "../../data/formDefaults";

// export default function GasSection({
//   form,
//   setField,
// }) {
//   return (
//     <SectionCard title="GAS">

//       <div className="border border-gray-300 bg-[#dbe9f5] p-4 space-y-3">

//         {/* CURRENT SUPPLIER */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Current Supplier *
//           </label>

//           <select
//             value={form.gasSupplier}
//             onChange={(e) => {
//               setField("gasSupplier")(e);

//               if (form.validationType === "Electricity + Gas") {
//                 setField("elecSupplier")(e);
//               }
//             }}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//               focus:outline-none focus:ring-1 focus:ring-blue-500
//             "
//           >
//             <option value="">Select Supplier</option>

//             {supplierOptions.map((item) => (
//               <option key={item} value={item}>
//                 {item}
//               </option>
//             ))}
//           </select>

//         </div>

//         {/* CUSTOMER ACCOUNT */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Customer Account No
//           </label>

//           <input
//             type="text"
//             value={form.gasAccount || ""}
//             onChange={setField("gasAccount")}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//               focus:outline-none focus:ring-1 focus:ring-blue-500
//             "
//           />

//         </div>

//         {/* MONTH & YEAR */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Month And Year
//           </label>

//           <input
//             type="month"
//             value={form.gasMonthYear || ""}
//             onChange={setField("gasMonthYear")}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//               focus:outline-none focus:ring-1 focus:ring-blue-500
//             "
//           />

//         </div>

//         {/* CONTRACT END DATE */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Contract End Date *
//           </label>

//           <input
//             type="date"
//             value={form.gasContractEnd}
//             onChange={setField("gasContractEnd")}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//               focus:outline-none focus:ring-1 focus:ring-blue-500
//             "
//           />

//         </div>

//         {/* PAYMENT METHOD */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Payment Method *
//           </label>

//           <select
//             value={form.gasPayment}
//             onChange={setField("gasPayment")}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//               focus:outline-none focus:ring-1 focus:ring-blue-500
//             "
//           >
//             <option value="">Select PaymentMethod</option>

//             {paymentMethodOptions.map((item) => (
//               <option key={item} value={item}>
//                 {item}
//               </option>
//             ))}
//           </select>

//         </div>

//         {/* ANNUAL CONSUMPTION */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Annual Consumption *
//           </label>

//           <input
//             type="text"
//             value={form.gasAnnualConsumption || ""}
//             onChange={setField("gasAnnualConsumption")}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//               focus:outline-none focus:ring-1 focus:ring-blue-500
//             "
//           />

//         </div>

//         {/* CURRENT RATE */}
//         <div className="border-t border-cyan-500 pt-3 mt-2">

//           <h3 className="text-[13px] font-bold uppercase text-gray-700 mb-3">
//             CURRENT RATE
//           </h3>

//           {/* DAY */}
//           <div className="flex items-center gap-3 mb-2">

//             <label className="w-44 text-[12px] text-gray-700">
//               Day
//             </label>

//             <input
//               type="text"
//               value={form.gasDayRate}
//               onChange={setField("gasDayRate")}
//               className="
//                 flex-1 border border-gray-400
//                 px-3 py-2 text-sm bg-white
//                 focus:outline-none focus:ring-1 focus:ring-blue-500
//               "
//             />

//           </div>

//           {/* STANDING CHARGE */}
//           <div className="flex items-center gap-3 mb-2">

//             <label className="w-44 text-[12px] text-gray-700">
//               Standing Charge
//             </label>

//             <input
//               type="text"
//               value={form.gasStandingCharge}
//               onChange={setField("gasStandingCharge")}
//               className="
//                 flex-1 border border-gray-400
//                 px-3 py-2 text-sm bg-white
//                 focus:outline-none focus:ring-1 focus:ring-blue-500
//               "
//             />

//           </div>

//           {/* MPRN NO */}
//           <div className="flex items-center gap-3 mb-2">

//             <label className="w-44 text-[12px] text-gray-700">
//               MPR No *
//             </label>

//             <input
//               type="text"
//               value={form.gasMprnNumber || ""}
//               onChange={setField("gasMprnNumber")}
//               className="
//                 flex-1 border border-gray-400
//                 px-3 py-2 text-sm bg-white
//                 focus:outline-none focus:ring-1 focus:ring-blue-500
//               "
//             />

//           </div>

//         </div>

//         {/* AVERAGE BILL */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Average Bill Amount *
//           </label>

//           <div className="flex gap-2 flex-1">

//             <input
//               type="text"
//               value={form.gasAvgBill || ""}
//               onChange={setField("gasAvgBill")}
//               className="
//                 flex-1 border border-gray-400
//                 px-3 py-2 text-sm bg-white
//                 focus:outline-none focus:ring-1 focus:ring-blue-500
//               "
//             />

//             <select
//               value={form.gasBillingFreq || ""}
//               onChange={setField("gasBillingFreq")}
//               className="
//                 w-26 border border-gray-400
//                 px-3 py-2 text-sm bg-white
//               "
//             >
//               <option value="MONTHLY">
//                 MONTHLY
//               </option>

//               <option value="QUARTERLY">
//                 QUARTERLY
//               </option>
//             </select>

//           </div>

//         </div>

//         {/* BILL RANGE */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             Average Bill Range
//           </label>

//           <select
//             value={form.gasBillRange || ""}
//             onChange={setField("gasBillRange")}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//             "
//           >
//             <option value="">Select</option>
//           </select>

//         </div>

//         {/* MSN */}
//         <div className="flex items-center gap-3">

//           <label className="w-44 text-[12px] font-semibold text-gray-700">
//             MSN No
//           </label>

//           <input
//             type="text"
//             value={form.gasMSN || ""}
//             onChange={setField("gasMSN")}
//             className="
//               flex-1 border border-gray-400
//               px-3 py-2 text-sm bg-white
//               focus:outline-none focus:ring-1 focus:ring-blue-500
//             "
//           />

//         </div>

//       </div>

//     </SectionCard>
//   );
// }

import SectionCard from "../ui/SectionCard";
import { supplierOptions, paymentMethodOptions } from "../../data/formDefaults";

function FieldError({ message }) {
  if (!message) return null;
  return <p className="text-red-500 text-[11px] mt-1">{message}</p>;
}

function inputCls(hasError) {
  return `
    flex-1 border px-3 py-2 text-sm text-gray-900 bg-white
    focus:outline-none focus:ring-1
    ${hasError ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
  `;
}

function selectCls(hasError) {
  return `
    flex-1 border px-3 py-2 text-sm text-gray-900 bg-white
    focus:outline-none focus:ring-1
    ${hasError ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
  `;
}

export default function GasSection({ form, errors = {}, setField }) {
  return (
    <SectionCard title="GAS">
      <div className="border border-gray-300 bg-[#dbe9f5] p-4 space-y-3">

        {/* CURRENT SUPPLIER */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Current Supplier *</label>
          <div className="flex-1">
            <select
              name="gasSupplier"
              value={form.gasSupplier}
              onChange={(e) => {
                setField("gasSupplier")(e);
                if (form.validationType === "Electricity + Gas") setField("elecSupplier")(e);
              }}
              className={selectCls(errors.gasSupplier)}
            >
              <option value="">Select Supplier</option>
              {supplierOptions.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
            <FieldError message={errors.gasSupplier} />
          </div>
        </div>

        {/* CUSTOMER ACCOUNT */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700">Customer Account No</label>
          <input name="gasAccount" type="text" value={form.gasAccount || ""} onChange={setField("gasAccount")} className={inputCls(false)} />
        </div>

        {/* MONTH & YEAR */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700">Month And Year</label>
          <input name="gasMonthYear" type="month" value={form.gasMonthYear || ""} onChange={setField("gasMonthYear")} className={inputCls(false)} />
        </div>

        {/* CONTRACT END DATE */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Contract End Date *</label>
          <div className="flex-1">
            <input name="gasContractEnd" type="date" value={form.gasContractEnd} onChange={setField("gasContractEnd")} className={inputCls(errors.gasContractEnd)} />
            <FieldError message={errors.gasContractEnd} />
          </div>
        </div>

        {/* PAYMENT METHOD */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Payment Method</label>
          <div className="flex-1">
            <select name="gasPayment" value={form.gasPayment} onChange={setField("gasPayment")} className={selectCls(errors.gasPayment)}>
              <option value="">Select PaymentMethod</option>
              {paymentMethodOptions.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
           
          </div>
        </div>

        {/* ANNUAL CONSUMPTION */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Annual Consumption *</label>
          <div className="flex-1">
            <input name="gasAnnualConsumption" type="text" value={form.gasAnnualConsumption || ""} onChange={setField("gasAnnualConsumption")} className={inputCls(errors.gasAnnualConsumption)} />
            <FieldError message={errors.gasAnnualConsumption} />
          </div>
        </div>

        {/* CURRENT RATE */}
        <div className="border-t border-cyan-500 pt-3 mt-2">
          <h3 className="text-[13px] font-bold uppercase text-gray-700 mb-3">CURRENT RATE</h3>

          {[
            { label: "Day", field: "gasDayRate" },
            { label: "Standing Charge", field: "gasStandingCharge" },
          ].map(({ label, field }) => (
            <div key={field} className="flex items-center gap-3 mb-2">
              <label className="w-44 text-[12px] text-gray-700">{label}</label>
              <input name={field} type="text" value={form[field] || ""} onChange={setField(field)} className={inputCls(false)} />
            </div>
          ))}

          {/* MPRN NO */}
          <div className="flex items-start gap-3 mb-2">
            <label className="w-44 text-[12px] text-gray-700 pt-2">MPR No *</label>
            <div className="flex-1">
              <input name="gasMprnNumber" type="text" value={form.gasMprnNumber || ""} onChange={setField("gasMprnNumber")} className={inputCls(errors.gasMprnNumber)} />
              <FieldError message={errors.gasMprnNumber} />  {/* ← must be here */}
            </div>
          </div>
        </div>

        {/* AVERAGE BILL */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Average Bill Amount</label>
          <div className="flex-1">
            <div className="flex gap-2">
              <input name="gasAvgBill" type="text" value={form.gasAvgBill || ""} onChange={setField("gasAvgBill")} className={`flex-1 border px-3 py-2 text-sm text-gray-900 bg-white focus:outline-none focus:ring-1 ${errors.gasAvgBill ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}`} />
              <select value={form.gasBillingFreq || ""} onChange={setField("gasBillingFreq")} className="w-26 border border-gray-400 px-3 py-2 text-sm bg-white text-gray-900">
                <option value="MONTHLY">MONTHLY</option>
                <option value="QUARTERLY">QUARTERLY</option>
              </select>
            </div>
           
          </div>
        </div>

        {/* BILL RANGE */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 ">Average Bill Range</label>
          <select value={form.gasBillRange || ""} onChange={setField("gasBillRange")} className="flex-1 border border-gray-400 px-3 py-2 text-sm bg-white text-gray-900">
            <option value="">Select</option>
            <option value="£0 - £500">£0 - £500</option>
            <option value="£500 - £1,000">£500 - £1,000</option>
            <option value="£1,000 - £2,500">£1,000 - £2,500</option>
            <option value="£2,500 - £5,000">£2,500 - £5,000</option>
            <option value="£5,000 - £10,000">£5,000 - £10,000</option>
            <option value="£10,000 - £25,000">£10,000 - £25,000</option>
            <option value="£25,000 - £50,000">£25,000 - £50,000</option>
            <option value="£50,000+">£50,000+</option>
          </select>
        </div>

        {/* MSN */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700">MSN No</label>
          <input name="gasMSN" type="text" value={form.gasMSN || ""} onChange={setField("gasMSN")} className={inputCls(false)} />
        </div>

      </div>
    </SectionCard>
  );
}
